import {component} from '@reduct/component';
import {Modal} from 'bootstrap'

@component({})
export default class Review {
    constructor() {
        this.galleryModalElement = document.getElementById('reviewGalleryModal');

        if (this.galleryModalElement === null) {
            return;
        }

        this.galleryModal = new Modal(this.galleryModalElement, {
            keyboard: false
        });

        $(this.el).find('a').click((e) => {
            e.preventDefault();

            let linkElement = e.currentTarget;
            const imageUrl = linkElement.href;

            let imageElement = document.createElement('img');
            imageElement.src = imageUrl;
            imageElement.className = 'img-fluid';

            $(this.galleryModalElement).find('.modal-body').html(imageElement);

            this.galleryModal.show();
        });
    }
}
